import React, { useContext } from "react";
import {
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

// Contexts
import FacebookProfilesDashboardContext from "../../../context/facebook_profiles/dashboard/DashboardContext";

// Components

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  button: {
    textTransform: "none",
    "&:focus": {
      outline: "none",
    },
  },
}));

const DeleteProfile = () => {
  const classes = useStyles();

  const { selected_profile, profile_form, setProfile, deleteProfile } =
    useContext(FacebookProfilesDashboardContext);

  const onDeleteProfile = () => {
    deleteProfile();
    onClose();
  };

  const onClose = () => {
    setProfile({ ...profile_form, action: "" });
  };

  return (
    <Dialog
      disableBackdropClick
      fullWidth
      maxWidth="xs"
      open={profile_form.action === "Delete"}
      onClose={onClose}
    >
      <DialogTitle> Delete Profile </DialogTitle>
      <DialogContent dividers>
        <Typography>
          Are you sure to delete this profile({" "}
          <strong> {selected_profile.profile_id} </strong>) ?{" "}
        </Typography>{" "}
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          color="primary"
          className={classes.button}
          onClick={onDeleteProfile}
        >
          Delete{" "}
        </Button>{" "}
        <Button
          variant="contained"
          color="secondary"
          className={classes.button}
          onClick={onClose}
        >
          Cancel{" "}
        </Button>{" "}
      </DialogActions>{" "}
    </Dialog>

    //   <Backdrop
    //   className={classes.backdrop}
    //   open={profile_form.action === "Delete"}
    // >
    //   <Card style={{ width: 350, padding: 10 }}>
    //     <Grid container direction="row" spacing={1}>
    //       <Grid item xs={12}>
    //         <Grid container direction="row" justifyContent="space-between">
    //           <Grid item>
    //             <Typography style={{ fontSize: 18 }}>
    //               Are you sure to delete this profile?
    //             </Typography>
    //           </Grid>
    //           <Grid item>
    //             <IconButton
    //               size="small"
    //               className={classes.button}
    //               onClick={onClose}
    //             >
    //               <CloseIcon color="primary" style={{ fontSize: 25 }} />
    //             </IconButton>
    //           </Grid>
    //         </Grid>
    //       </Grid>
    //       <Grid item xs={12}>
    //         <Grid container direction="row" justifyContent="flex-end" spacing={1}>
    //           <Grid item>
    //             <Button className={classes.button} onClick={onDeleteProfile}>
    //               Yes
    //             </Button>
    //           </Grid>
    //           <Grid item>
    //             <Button className={classes.button} onClick={onClose}>
    //               No
    //             </Button>
    //           </Grid>
    //         </Grid>
    //       </Grid>
    //     </Grid>
    //   </Card>
    // </Backdrop>
  );
};

export default DeleteProfile;
